import StaffRepository from './staffRepository';
import PermissionsRepository from './PermissionsRepository';
import RolesRepository from './RolesRepository';
import GlobalRepository from './GlobalRepository';
import FileRepository from "@/repository/FileRepository";
import UserRepository from "@/repository/userRepository";
import TenantRepository from "@/repository/TenantRepository";
import LocalizationRepository from '@/repository/LocalizationRepository'
import AuthRepository from '@/repository/AuthRepository'
import ObjectRepository from '@/repository/ObjectRepository'
import AdminRepository from '@/repository/AdminRepository';
import ActionRepository from '@/repository/ActionRepository';
import ReportTemplateRepository from '@/repository/ReportTemplateRepository';
import DropdownRepository from '@/repository/DropdownRepository';
import ReportRepository from '@/repository/ReportRepository';
import SalesforceRepository from '@/repository/SalesforceRepository';

const repositories = {
  staff : StaffRepository,
  permissions : PermissionsRepository,
  roles : RolesRepository,
  global: GlobalRepository,
  file: FileRepository,
  user: UserRepository,
  tenant: TenantRepository,
  localization: LocalizationRepository,
  auth: AuthRepository,
  object: ObjectRepository,
  admin: AdminRepository,
  action: ActionRepository,
  report_template: ReportTemplateRepository,
  drop_down: DropdownRepository,
  report: ReportRepository,
  sf: SalesforceRepository
};

export const RepositoryFactory = {
  get: name => repositories[name]
};
